
export const LOCATION_FORM_OBJECT = {
    cityField: "misdeliveryCity",
    zipField: "misdeliveryZip",
    destinationField: "pickupTerminal",
    stateField: "misdeliveryState",
    cityLabel: "City",
    zipLabel: "Zipcode",
    stateLabel: "State",
    destinationLabel: "Pickup Terminal",
};

export const CURRENT_LOCATION_FORM_OBJECT = {
    cityField: "currentLocationCity",
    zipField: "currentLocationZip",
    stateField: "currentLocationState",
    cityLabel: "City",
    zipLabel: "Zipcode",
    stateLabel: "State",
    destinationField: "pickupTerminal",
    destinationLabel: "Pickup Terminal",
};
